import { ecsApi, GetPpspsByWorksiteIdRequest, GetPpspsByWorksiteIdResponse } from '@services';

export const ppspsApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getPpspsByWorksiteId: builder.mutation<GetPpspsByWorksiteIdResponse, GetPpspsByWorksiteIdRequest>({
            query: ({ worksiteId }) => ({
                url: `/worksites/${worksiteId}/ppsps`,
                method: 'GET'
            })
        })
    })
});

export const { useGetPpspsByWorksiteIdMutation } = ppspsApi;
